import Flatpickr from 'react-flatpickr';
import { FC, memo } from 'react';
import { InputGroup } from 'react-bootstrap';

import { DateTimePickerProps } from './types';

// Use type assertion to fix TypeScript compatibility issues with react-flatpickr 4.0.1
const FlatpickrComponent = Flatpickr as any;

const Component: FC<DateTimePickerProps> = memo((props) => {
    const {
        disabled = false,
        required = false,
        value = '',
        enableTime = true,
        calendarIcon = 'fas fa-calendar-alt',
        options = {},
        onChange,
        ...restProps
    } = props;

    return (
        <>
            <FlatpickrComponent
                disabled={disabled}
                required={required}
                value={value}
                options={options}
                data-enable-time={enableTime}
                className="form-control"
                onChange={(value: Date[]) => onChange(value)}
                {...restProps}
            />
            <InputGroup.Text>
                <i className={calendarIcon} />
            </InputGroup.Text>
        </>
    );
});
Component.displayName = 'DateTimePicker';
export const DateTimePicker: FC<DateTimePickerProps> = Object.assign(Component, {});
